module.exports = __webpack_public_path__ + "img/xxlj_icon_6.a7f7b0c1.svg";